import React from "react";
import { Link } from "react-router-dom";
import { ExternalLink, Sparkles, X } from "lucide-react";

const PARTNER = {
  type: process.env.REACT_APP_PARTNER_TYPE || "",
  name: process.env.REACT_APP_PARTNER_NAME || "",
  copy: process.env.REACT_APP_PARTNER_COPY || "",
  url: process.env.REACT_APP_PARTNER_URL || "",
  cta: process.env.REACT_APP_PARTNER_CTA || "Learn more",
};

function hasPartnerCampaign() {
  return ["sponsor", "affiliate"].includes(PARTNER.type) && PARTNER.name && PARTNER.copy && /^https:\/\//.test(PARTNER.url);
}

// The slot is shown only to non-premium users by FeedPage. A complete, approved
// campaign replaces the HAEVEN Calm house ad; incomplete config safely falls back.
export default function CalmAdSlot({ onDismiss }) {
  const partnerCampaign = hasPartnerCampaign();

  return (
    <div
      data-testid="calm-ad-slot"
      className="brutal-card bg-sage p-5 flex items-start gap-4 animate-fade-up"
    >
      <div className="hidden sm:flex w-12 h-12 rounded-xl border-2 border-foreground bg-accent items-center justify-center shrink-0">
        {partnerCampaign ? <ExternalLink size={22} strokeWidth={2.5} /> : <Sparkles size={22} strokeWidth={2.5} />}
      </div>
      <div className="flex-1">
        <div className="text-[10px] uppercase tracking-widest font-bold opacity-70">
          {partnerCampaign
            ? PARTNER.type === "affiliate"
              ? "Partner offer · HAEVEN may earn a commission"
              : "Sponsored"
            : "Sponsored · HAEVEN"}
        </div>
        <h3 className="text-xl mt-0.5 font-display">
          {partnerCampaign ? PARTNER.name : "Scroll without the noise."}
        </h3>
        <p className="text-sm mt-1 leading-snug">
          {partnerCampaign
            ? PARTNER.copy
            : "HAEVEN Calm removes this slot, unlocks private journaling and a weekly AI mood reflection from $4.99."}
        </p>
        {partnerCampaign ? (
          <a
            href={PARTNER.url}
            target="_blank"
            rel="noopener noreferrer sponsored"
            data-testid="partner-ad-cta"
            className="brutal-btn bg-primary text-primary-foreground inline-flex items-center gap-2 mt-3 px-4 py-2 text-sm font-semibold"
          >
            {PARTNER.cta} <ExternalLink size={14} strokeWidth={2.5} />
          </a>
        ) : (
          <Link
            to="/premium"
            data-testid="calm-ad-cta"
            className="brutal-btn bg-primary text-primary-foreground inline-block mt-3 px-4 py-2 text-sm font-semibold"
          >
            Try Calm
          </Link>
        )}
      </div>
      {onDismiss && (
        <button
          onClick={onDismiss}
          data-testid="calm-ad-dismiss"
          aria-label="Dismiss"
          className="brutal-btn bg-card p-1 shrink-0"
        >
          <X size={14} strokeWidth={2.5} />
        </button>
      )}
    </div>
  );
}
